import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createProgramme, type ProgrammeDto } from "../api/programmesApi";
import { queryKeys } from "../lib/queryKeys";

export function useCreateProgramme() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: ProgrammeDto) => createProgramme(dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.programmes.all });
    },
  });
}
